import isPromise from 'utils/isPromise';

const processValidation = (fn, start, stop, field) => {
  start(field);
  const promise = fn();
  if (!isPromise(promise)) {
    stop();
    return;
    //throw new Error('Validate function passed to Form must return a promise');
  }
  const handleErrors = rejected => errors => {
    if (errors && Object.keys(errors).length) {
      stop(errors);
      return errors;
    } else if (rejected) {
      stop();
      throw new Error('Validation promise was rejected without errors.');
    }
    stop();
    return Promise.resolve();
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

export default processValidation;
